import { render, staticRenderFns } from "./BusinessSuccess.vue?vue&type=template&id=1f20d230&scoped=true&"
import script from "./BusinessSuccess.vue?vue&type=script&lang=js&"
export * from "./BusinessSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSuccess.vue?vue&type=style&index=0&id=1f20d230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20d230",
  null
  
)

export default component.exports